import "./styles.css";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { GLBalanceWizard } from "./glBalanceWizard";
import { GLRangeWizard } from "./glRangeWizard";
import { ThirdPartyWizard } from "./thirdPartyWizard";

enum FormulaType {
  ftList,
  ftGLBalance,
  ftGLRange,
  ftThirdParty,
}

export const FormulasList: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const [currentFormula, setCurrentFormula] = useState(FormulaType.ftList);

  const onClickBackButton = () => {
    setCurrentFormula(FormulaType.ftList);
  };

  async function onGLBalanceWizardDisplay() {
    setCurrentFormula(FormulaType.ftGLBalance);
  }

  async function onThirdPartyWizardDisplay() {
    setCurrentFormula(FormulaType.ftThirdParty);
  }

  async function onGLRangeWizardDisplay() {
    setCurrentFormula(FormulaType.ftGLRange);
  }

  switch (currentFormula) {
    case FormulaType.ftList:
      return (
        <div className="pt-4">
          <div className="mt-1 mb-2 ms-fontWeight-bold">
            <span>{t("formulas")}</span>
          </div>
          <div className="card card-formula mb-4" onClick={onGLBalanceWizardDisplay}>
            <div className="card-body">
              <h5 className="card-title">{t("glBalanceFormula")}</h5>
              <p className="card-text">{t("glBalanceFormulaDesc")}</p>
            </div>
          </div>
          <div className="card card-formula mb-4" onClick={onThirdPartyWizardDisplay}>
            <div className="card-body">
              <h5 className="card-title">{t("thirdPartyFormula")}</h5>
              <p className="card-text">{t("thirdPartyFormulaDesc")}</p>
            </div>
          </div>
          <div className="card card-formula mb-4" onClick={onGLRangeWizardDisplay}>
            <div className="card-body">
              <h5 className="card-title">{t("glRangeFormula")}</h5>
              <p className="card-text">{t("glRangeFormulaDesc")}</p>
            </div>
          </div>
        </div>
      );
    case FormulaType.ftGLBalance:
      return <GLBalanceWizard onBackClick={() => onClickBackButton()}></GLBalanceWizard>;
    case FormulaType.ftThirdParty:
      return <ThirdPartyWizard onBackClick={() => onClickBackButton()}></ThirdPartyWizard>;
    case FormulaType.ftGLRange:
      return <GLRangeWizard onBackClick={() => onClickBackButton()}></GLRangeWizard>;
  }
};
